var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Shared between chakra's Select and DropDown
 */
var selectHeight = '56px';
export var selectSizes = {
    md: {
        field: { height: selectHeight },
    },
};
export var selectOutlineFieldStyles = {
    color: 'gray.700',
    backgroundColor: 'white',
    borderRadius: '4px',
    borderColor: 'gray.350',
    _placeholder: {
        color: 'gray.500',
    },
    _hover: {
        borderColor: 'gray.700',
        _invalid: {
            borderColor: 'red.500',
        },
    },
    _focus: {
        borderColor: 'gray.700',
        _invalid: {
            borderColor: 'red.500',
            backgroundColor: 'red.100',
        },
    },
    _invalid: {
        borderColor: 'red.500',
        color: 'red.500',
        backgroundColor: 'red.100',
        boxShadow: "0 0 0 2px #AE3131",
    },
    _disabled: {
        borderColor: 'gray.350',
    },
};
/**
 * DropDown only
 */
/**
 * The chakra-react-select API to provide the react-select styles prop.
 * See the docs for more info: https://github.com/csandman/chakra-react-select#chakrastyles
 */
export var chakraStyles = {
    menu: function (provided, state) { return (__assign(__assign({}, provided), { minW: '100%', 
        // This ensures the width of the menu expands to fit its content.
        w: 'auto', mt: 1, color: 'gray.700', boxShadow: '0px 3px 12px rgba(0, 0, 0, 0.15)' })); },
    // The input and dropdownIndicator (icon) container
    control: function (provided, state) { return (__assign(__assign(__assign({}, provided), selectOutlineFieldStyles), { 
        // Passing in the size prop to the Select doesn't work, so we need height
        minHeight: selectHeight, py: '14px' })); },
    indicatorSeparator: function (provided, state) { return (__assign(__assign({}, provided), { borderColor: 'transparent', backgroundColor: 'transparent' })); },
    dropdownIndicator: function (provided, state) { return (__assign(__assign({}, provided), { backgroundColor: 'transparent', pr: 2 })); },
};
